import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import { Fade, Paper, Popper } from '@material-ui/core';
import { useLocalizedMessage } from '../../../util/useLocalizedMessage';

const ColorPicker = ({
  value,
  onChange,
  label,
}) => {
  const localizeMessage = useLocalizedMessage();
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget);
    setDisplayColorPicker(!displayColorPicker);
  };
  const handleClose = () => setDisplayColorPicker(false);

  return (
    <div>
      <button
        type="button"
        className="cp-swatch"
        aria-label={label || localizeMessage('component.colorPicker.chooseColor')}
        aria-expanded={displayColorPicker}
        onClick={handleClick}
      >
        <div
          className="cp-color"
          style={{ backgroundColor: value }}
          aria-hidden="true"
        />
      </button>
      {
        displayColorPicker
          ? <div className="cp-cover" onClick={handleClose} />
          : null
      }
      <Popper
        open={displayColorPicker}
        anchorEl={anchorEl}
        placement="bottom"
        transition
        modifiers={{ name: 'flip', options: { fallbackPlacements: ['top', 'bottom'] } }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <SketchPicker
                color={value}
                onChange={(e) => onChange(e.hex)}
              />
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

ColorPicker.defaultProps = {
  label: null,
};

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default ColorPicker;
